module.exports = __webpack_public_path__ + "static/media/notifications-activer-active-cercle.e8369ee3.png";